import { useMutation } from '@apollo/client';
import { errorHandler } from 'utils/ErrorHandler';
import {
  PACK_DELIVERIES,
  RESTREAT_PACKING_DELIVERIES,
  ISSUE_DELIVERIES,
  COMPLETE_DELIVERIES,
  CONFIRM_DELIVERIES,
} from '..';
import { TrackingInfoInput } from '../types';

export function useMutationDeliveries() {
  const [packDeliveries] = useMutation(PACK_DELIVERIES);
  const [retreatPackingDeliveries] = useMutation(RESTREAT_PACKING_DELIVERIES);
  const [issueDeliveries] = useMutation(ISSUE_DELIVERIES);
  const [completeDeliveries] = useMutation(COMPLETE_DELIVERIES);
  const [confirmDeliveries] = useMutation(CONFIRM_DELIVERIES);

  const handlePackDeliveries = async (ids: string[], callback: () => void) => {
    try {
      const response = await packDeliveries({ variables: { ids } });

      if (response) {
        callback();

        window.showToast('배송 준비 상태로 변경되었습니다.', 'success');
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleRetreatPackingDeliveries = async (
    ids: string[],
    callback: () => void,
  ) => {
    try {
      const response = await retreatPackingDeliveries({ variables: { ids } });

      if (response) {
        callback();

        window.showToast('배송 준비 철회로 상태가 변경되었습니다.', 'default');
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleIssueDeliveries = async (
    trackingInfos: TrackingInfoInput[],
    callback: () => void,
  ) => {
    try {
      const response = await issueDeliveries({ variables: { trackingInfos } });

      if (response) {
        callback();

        window.showToast('배송중 상태로 변경되었습니다.', 'success');
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleCompleteDeliveries = async (
    ids: string[],
    callback: () => void,
  ) => {
    try {
      const response = await completeDeliveries({ variables: { ids } });

      if (response) {
        callback();

        window.showToast('배송완료 상태로 변경되었습니다.', 'success');
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleConfirmDeliveries = async (
    ids: string[],
    callback: () => void,
  ) => {
    try {
      const response = await confirmDeliveries({ variables: { ids } });

      if (response) {
        callback();

        window.showToast('구매확정 상태로 변경되었습니다.', 'success');
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return {
    handlePackDeliveries,
    handleRetreatPackingDeliveries,
    handleIssueDeliveries,
    handleCompleteDeliveries,
    handleConfirmDeliveries,
  };
}
